<template>
  <div class="bg">
    <div class="content">
      <el-card>
        <el-row>
          <el-col :span="24">
            <span> 所属项目：{{ detailInfo.projectId }} </span>
          </el-col>
          <el-col :span="24">
            <span v-if="'unitId' in detailInfo == true">
              参建单位：{{ detailInfo.unitId }}
            </span>
            <span v-if="'unitId' in detailInfo == false">参建单位：暂无信息</span>
          </el-col>
          <el-col :span="24">
            <span v-if="'teamId' in detailInfo == true">
              所属班组：{{ detailInfo.teamId }}
            </span>
            <span v-if="'teamId' in detailInfo == false">所属班组：暂无信息</span>
          </el-col>
          <el-col :span="24">
            <span v-if="'workType' in detailInfo == true"
              >所属工种：{{ detailInfo.workType }}</span
            >
            <span v-if="'workType' in detailInfo == false">所属工种：暂无信息</span>
          </el-col>
          <el-col :span="24">
            <span>联系电话：{{ detailInfo.phone }}</span>
          </el-col>
          <el-col :span="24">
            <span>认证状态：{{ detailInfo.status }}</span>
          </el-col>
          <el-col :span="24">
            <span>认证结果：{{ detailInfo.result }}</span>
          </el-col>
        </el-row>
      </el-card>
      <el-card>
        <el-row>
          <el-col :span="24">
            <span>大头照：</span>
            <van-image
              @click="showImageHead(detailInfo.head)"
              height="350"
              fit="contain"
              :src="detailInfo.head"
            />
          </el-col>
          <el-col :span="24">
            <span>头像面：</span>
            <van-image
              @click="showImageFront(detailInfo.front)"
              height="350"
              fit="contain"
              :src="detailInfo.front"
            />
          </el-col>
          <el-col :span="24">
            <span>国徽面：</span>
            <van-image
              @click="showImageBack(detailInfo.back)"
              height="350"
              fit="contain"
              :src="detailInfo.back"
          /></el-col>
        </el-row>
      </el-card>
    </div>
  </div>
</template>
<script>
import { ImagePreview } from "vant";
import { postDictCode } from "@/api/dict";
import { postListUnit } from "@/api/app/unit";
import { postTeamDetail } from "@/api/app/team";
import { postProjectId } from "@/api/app/project";
import { postDetail } from "@/api/app/certificationRecord";
export default {
  data() {
    return {
      detailInfo: {},
    };
  },
  created() {
    this.detail();
  },
  methods: {
    // 获取详情
    detail() {
      // 认证记录详情
      postDetail(this.$store.state.app.itemId).then((a) => {
        // 所属项目
        postProjectId(a.data.projectId).then((b) => {
          this.detailInfo["projectId"] = b.data.name;
        });
        // 参建单位
        postListUnit(a.data.projectId).then((c) => {
          c.data.find((item) => {
            if (a.data.unitId == item.id) {
              this.detailInfo["unitId"] = item.title;
            }
          });
        });
        // 所属班组
        if ("teamId" in a.data == true) {
          postTeamDetail(a.data.teamId).then((d) => {
            this.detailInfo["teamId"] = d.data.name;
          });
        }
        // 所属工种
        postDictCode("work_type").then((e) => {
          e.data.find((item) => {
            if (a.data.workType == item.value) {
              this.detailInfo["workType"] = item.label;
            }
          });
        });
        // 认证状态
        postDictCode("authentication_status").then((f) => {
          f.data.find((item) => {
            if (a.data.status == item.value) {
              this.detailInfo["status"] = item.label;
            }
          });
        });
        this.detailInfo = a.data;
      });
    },
    // 图片预览
    // 图片预览
    showImageHead(index) {
      ImagePreview({
        images: [index],
      });
    }, // 图片预览
    showImageFront(index) {
      ImagePreview({
        images: [index],
      });
    }, // 图片预览
    showImageBack(index) {
      ImagePreview({
        images: [index],
      });
    },
  },
};
</script>
<style lang="less" scoped>
.bg {
  margin-bottom: 40px;
  padding: 10px;
  min-height: 100vh;

  background-color: #f0f0f0;
}
.content {
  .el-card {
    margin-bottom: 10px;
    .el-tag {
      margin-bottom: 5px;
    }
    p,
    .el-col {
      font-size: 14px;
      margin-bottom: 5px;
    }
    span {
      font-size: 14px;
    }
    .img {
      img {
        width: 130px;
        height: 130px;
        border-radius: 4px;
      }
    }
  }
}
</style>
